import {countries} from "@/store/modules/country";
import {states} from "@/store/modules/state";
import {regions} from "@/store/modules/region";
import {autocomplete} from "@/store/modules/autocomplete";
import {towns} from "@/store/modules/town";
import {itenary} from "@/store/modules/itenary";
import {shires} from "@/store/modules/shires";
import {pages} from "@/store/modules/pages";
import {createStore} from 'vuex';

const store = createStore({
    modules: {
        countries,
        states,
        regions,
        towns,
        shires,
        pages,
        autocomplete,
        itenary
    }
});

export default store;

